import * as React from "react";
import { Message } from "../models";
import { IconConfusedFace, IconChatBox } from "../utils";

export interface MessagesProps {
    messages: Message[];
}

export const Messages = ({ messages }: MessagesProps) => {

    if (messages === null || typeof messages === 'undefined') {
        return <div className="app-messages app-messages-loading">
            <div className="lds-heart"><div></div></div>
        </div>;
    }

    if (messages.length === 0) {
        return <div className="app-messages app-messages-empty">
            <IconChatBox />
            <span>Šiuo metu žinučių nėra.</span>
        </div>;
    }

    return <div className="app-messages app-messages-list">
        <ul>
            {messages.map((message, index) => <li key={index}>
                <a href={`/zinutes/message/list?threadId=${message.id}`}>
                    <div className="message-photo"><img src={message.user.photo} /></div>
                    <div className="message-message">
                        <div className="user-name">
                            {message.user.name}, {message.user.age}
                            {message.unread ? <span className="message-unread">N</span> : null}
                        </div>
                        <div>
                            <span dangerouslySetInnerHTML={{ __html: (message.answered ? '<img src="//img.draugas.lt/images/atsakytas.png" style="margin-right: 4px;" />' : '') + message.message.replace(/\\"/g, '"') }}></span>
                        </div>
                    </div>
                    <div className="message-call-to-action">
                        <div className="button button-red">Rašyti</div>
                    </div>
                </a>
            </li>)}
        </ul>
    </div>;
}
